import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { MdSettings, MdBusiness, MdPayment, MdAssignment, MdLoyalty, MdLock } from 'react-icons/md';
import BillingSettings from './BillingSettings';
import ContractsSettings from './ContractsSettings';
import PointsSettings from './PointsSettings';
import SecuritySettings from './SecuritySettings';
import GeneralSettingsPage from './GeneralSettingsPage';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const SettingsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('general');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tab = params.get('tab');
        if (tab) {
            setActiveTab(tab);
        }
    }, [location.search]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return <GeneralSettingsPage />;
            case 'billing':
                return <BillingSettings />;
            case 'contracts':
                return <ContractsSettings />;
      case 'points':
        return <PointsSettings />;
      case 'security':
        return <SecuritySettings />;
      default:
        return <GeneralSettingsPage />;
    }
  };

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={<MdSettings size={28} />}>{t('Settings.title')}</PageTitle>
            </PageHeader>
            <PageContent>
                <TabBar>
                    <TabButton
                        active={activeTab === 'general'}
                        onClick={() => setActiveTab('general')}
                        icon={<MdBusiness />}
                    >
                        {t('Settings.general')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'billing'}
                        onClick={() => setActiveTab('billing')}
                        icon={<MdPayment />}
                    >
                        {t('Settings.billing')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'contracts'}
                        onClick={() => setActiveTab('contracts')}
                        icon={<MdAssignment />}
                    >
                        {t('Settings.contracts')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'points'}
                        onClick={() => setActiveTab('points')}
                        icon={<MdLoyalty />}
                    >
                        {t('Settings.points')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'security'}
                        onClick={() => setActiveTab('security')}
                        icon={<MdLock />}
                    >
                        {t('Settings.security', { defaultValue: 'Security' })}
                    </TabButton>
                </TabBar>
                <div style={{ marginTop: '24px' }}>
                    {renderTabContent()}
                </div>
            </PageContent>
        </PageContainer>
    );
};

export default SettingsPage;
